"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironmentProps = void 0;
function getEnvironmentProps(env, config) {
    if (env == null) {
        throw new Error('No environment dictionary provided');
    }
    const props = {};
    if (config != null) {
        for (const name of Object.keys(config)) {
            props[name] = config[name](env);
        }
    }
    return props;
}
exports.getEnvironmentProps = getEnvironmentProps;
//# sourceMappingURL=get-environment-props.js.map